export const hasCodeChars = (text) => {
  return /[{}[\]();:=<>+\-*%&|^!~`]/.test(text);
};

export const hasArabic = (text) => {
  return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(text);
};

const isArabicDominant = (text) => {
  const arabicCount = (text.match(/[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/g) || []).length;
  const nonSpaceLength = text.replace(/\s/g, "").length;
  return nonSpaceLength > 0 && arabicCount / nonSpaceLength >= 0.2;
};

// Returns "ltr" if no option contains Arabic, "rtl" if any option does (default RTL)
export const getOptionsDirection = (options) => {
  if (!options || options.length === 0) return "rtl";
  const hasAnyArabic = options.some((opt) => hasArabic(opt.option || ""));
  return hasAnyArabic ? "rtl" : "ltr";
};

// LTR for options that look like code: start with . or # (selectors), or end with ()
export const isOptionLTR = (text) => {
  if (!text) return false;
  const trimmed = text.trim();
  if (/^[.#]/.test(trimmed)) return true;
  if (/\(\s*\)\s*$/.test(trimmed)) return !isArabicDominant(trimmed);
  return false;
};

// LTR when text has code symbols + English letters AND Arabic is not the dominant content
export const isCodeLTR = (text) => {
  if (!text) return false;
  const trimmed = text.trim();
  if (/^[.#]/.test(trimmed)) return true;
  if (/\(\s*\)\s*$/.test(trimmed) && !isArabicDominant(trimmed)) return true;
  if (/<[a-zA-Z!]/.test(text)) {
    const arabicCount = (text.match(/[\u0600-\u06ff\u0750-\u077f\u08a0-\u08ff\ufb50-\ufdff\ufe70-\ufeff]/g) || []).length;
    const nonSpaceLength = text.replace(/\s/g, "").length;
    if (arabicCount / nonSpaceLength >= 0.2) return false; // Arabic-dominant mixed content \u2192 RTL
    return /[\r\n]/.test(text) || /=["']/.test(text); // pure code: multiline or has attributes \u2192 LTR, plain tag \u2192 RTL
  }
  // Pure non-Arabic text with Latin letters → LTR (e.g. "for", "while", "true", "false")
  if (!/[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/.test(text) && /[a-zA-Z]/.test(text)) return true;
  if (!hasCodeChars(text) || !/[a-zA-Z]/.test(text)) return false;
  if (/^[a-zA-Z0-9\s()\[\]{}!_-]+$/.test(text)) return false; // only letters/digits/parens/braces/spaces/hyphens/! \u2192 plain identifier \u2192 RTL
  const colonIdx = text.indexOf(":");
  if (colonIdx > 0 && !/[\r\n]/.test(text) && /\s/.test(text.substring(0, colonIdx)) && !/[?]/.test(text)) return false; // single-line with space before colon \u2192 natural language sentence \u2192 RTL
  if (/^[\s\r\n]*[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(text)) return false; // starts with Arabic \u2192 RTL
  const arabicCount = (text.match(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g) || []).length;
  const nonSpaceLength = text.replace(/\s/g, "").length;
  return arabicCount / nonSpaceLength < 0.2;
};
